import { z } from 'zod';
export var School = z.object({
  id: z.string(),
  name: z.string(),
  flag: z.string(),
  country: z.string(),
  countryCode: z.string(),
  slug: z.string(),
  logo: z.object({
    url: z.string().nullish()
  }).nullish()
});
export var SchoolResponse = z.object({
  attributes: z.object({}).passthrough(),
  id: z.string(),
  type: z.literal('school')
});